import { createI18n } from 'vue-i18n';

// Definir los mensajes de traducción
import en from '../locales/en.json';
import es from '../locales/es.json';
import pt from '../locales/pt.json';

const messages = {
  en,
  es,
  pt
};

// Configuración de i18n
const i18n = createI18n({
  legacy: false, // Asegúrate de que 'legacy' esté en false (esto desactiva el modo legacy)
  locale: 'en', // Idioma predeterminado
  fallbackLocale: 'en', // Idioma de respaldo
  messages, // Mensajes de traducción
});

export default i18n;
